import translate from 'counterpart';

const buttonWithCustomText = (translatePath) => ({
    'visible': true,
    'text': {
        'rus': translate(translatePath, { locale: 'ru' }),
        'enu': translate(translatePath, { locale: 'en' }),
    }
});

export const sendSaveButton = buttonWithCustomText('events.save');
